'use client'

import styled from "styled-components";
import {getVariantStyles} from "@/components/UI/Button/options/variant.options";
import {getColorStyles} from "@/components/UI/Button/options/color.options";
import {getSizeStyles} from "@/components/UI/Button/options/size.options";
import Loading from "../Loading/Loading";

export const ButtonLoader = styled(Loading)`
    position: absolute;
    z-index: 4;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`


export const ButtonStyled = styled.button`
    position: relative;
    height: auto;
    transition: none;
    border-radius: 0.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 19px;
    
    div[style] {
        display: none;
    }
    
    &:hover {
        transition: none;
    }

    &:disabled {
        opacity: 0.75;
        cursor: not-allowed;
    }
    
    & > *:not(${ButtonLoader}) {
       opacity: ${({ $loading }) => ($loading ? 0 : 1)};
    }
    
    ${getColorStyles}
    ${getVariantStyles}
    ${getSizeStyles}
    
     &, &:hover {
       color: ${({ $loading }) => ($loading ? 'transparent !important' : false)};
    }
`
